// Event discovery is still being built, so for now only this account can open
// it. This only hides the screens; the API itself is open to any signed-in
// user and returns public event listings.
const ALLOWED_EMAILS = ["beelgulzar@gmail.com"];

export const canUseEventDiscovery = (
  user?: { email?: string | null } | null,
): boolean =>
  ALLOWED_EMAILS.includes(
    String(user?.email || "")
      .trim()
      .toLowerCase(),
  );
